import { EvIcon, EvLink } from '@evinced-private/ui-common';
import React from 'react';
import NotFoundIcon from '../../icons/NotFoundIcon.svg';
import './NotFound404Page.scss';

const notFoundErrMsg = 'Sorry, we couldn\'t find what you were looking for...';

export default (): JSX.Element => {
	return (
		<div className="error-404">
			<div className="error-404-content">
				<EvIcon icon={NotFoundIcon} />
				<div className="text-messge">
					<p>{notFoundErrMsg}</p>
					<EvLink
						url="/"
						className="back"
						linkText="Back"
						isNew
					/>
				</div>
			</div>
		</div>
	);
};
